let Init = {
    init: function () {
        this.bind();
    },

    bind: function () {
        this.toastr();
        this.select2();
        this.datepicker();
        this.datetimepicker();
        this.tooltip();
        this.tinymce();
    },

    toastr: function () {
        toastr.options = {
            "debug": false,
            "newestOnTop": false,
            "positionClass": "toast-top-right",
            "closeButton": true,
            "toastClass": "animated fadeInDown",
        };
    },

    select2: function () {
        $('.select2').select2({
            theme: "bootstrap"
        });
    },

    datepicker: function () {
        $('.datepicker').datepicker({
            format: 'd/m/yyyy'
        });
    },

    datetimepicker: function () {
        $('.datetimepicker').datetimepicker({
            format: 'DD/MM/Y hh:mm:ss A',
        });
    },

    tooltip() {
        $('[data-toggle="tooltip"]').tooltip();
    },

    tinymce() {
        tinymce.init({
            selector: 'textarea.tinymce',
            width: '100%',
            height: 300,
            plugins : 'advlist autolink link image lists charmap print preview table media hr code'
        });
    }
};

$().ready(function () {
    window.Init = Init;
    window.Init.init();
});
